<template>
    <div class="appdetail">
            <!-- 标题、按钮 -->
            <div class="appdetail-title">
                <div class="appdetail-title-top clearfix">
                    <div class="app-buttons">
                        <el-button icon="icon-save" class="btn-" type="primary" size="mini" @click="saveBtn">
                            <font>保存</font>
                        </el-button>
                    </div>
                </div>
            </div>
            <el-tabs class="appdetail-content" type="border-card" v-model="currentDetailTabsModel" @tab-click="tabClick">
          <el-tab-pane label="列表" name="列表">
          </el-tab-pane>
          <el-tab-pane label="详情" name="详情">
            <div class="appdetail-content" :style="{height: 'calc(100vh - 205px)'}">
          <el-form :show-message="false" inline-message :model="numbsetForm" :rules="rules" ref="numbsetForm">
            <div class="content-accordion">
              <el-collapse v-model="activeNames">
                <el-collapse-item title="基础信息" name="1">
                  <el-row>
                    <el-col :span="8">
                      <el-form-item label="自定义设置" prop="isCustomUse" label-width="120px">
                        <el-select v-model="numbsetForm.isCustomUse" placeholder="请选择" style="width:100%;">
                          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="使用多流水号" prop="isMultiple" label-width="120px">
                        <el-select v-model="numbsetForm.isMultiple" placeholder="请选择" style="width:100%;">
                          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row v-show='numbsetForm.isCustomUse=="1"'>
                    <el-col :span="8">
                      <el-form-item label="标识一" prop="markx" label-width="120px">
                        <el-input placeholder="请输入" v-model="numbsetForm.markx"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="标识二" prop="marky" label-width="120px">
                        <el-input placeholder="请输入" v-model="numbsetForm.marky"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="标识三" prop="markz" label-width="120px">
                        <el-input placeholder="请输入" v-model="numbsetForm.markz"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row v-show='numbsetForm.isCustomUse!="1"'>
                    <el-col :span="8">
                      <el-form-item label="应用" prop="markx" label-width="120px">
                        <el-input placeholder="请选择" v-model="numbsetForm.markx" :disabled="edit" width="100%">
                          <el-button slot="append" icon="el-icon-search" @click="getapp()">
                          </el-button>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="表" prop="marky" label-width="120px">
                        <el-input placeholder="请选择" v-model="numbsetForm.marky" :disabled="edit">
                          <el-button slot="append" icon="el-icon-search" @click="getdata()">
                          </el-button>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="编号列" prop="columnname" label-width="110px">
                        <el-input placeholder="请选择" v-model="numbsetForm.columnname" :disabled="edit">
                          <el-button slot="append" icon="el-icon-search" @click="getcolumnname(numbsetForm.marky)">
                          </el-button>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="8">
                      <el-form-item label="初始化日期" prop="isInitbydate" label-width="120px">
                        <el-select v-model="numbsetForm.isInitbydate" placeholder="请选择" style="width:100%;">
                          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="初始化日期格式" prop="initformat" label-width="120px" :rules="numbsetForm.isInitbydate == '1'?rules.initformat:[{ required: false, message: '请选择任务启动时间', trigger: 'blur' }]">
                        <el-select v-model="numbsetForm.initformat" placeholder="请选择" style="width:100%;">
                          <el-option v-for="item in initDateFormatoption" :key="item.id" :label="item.name" :value="item.code">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="初始化起始数" prop="initnum" label-width="120px">
                        <el-input placeholder="请输入" v-model="numbsetForm.initnum"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="8">
                      <el-form-item label="保留位数" prop="retain" label-width="120px">
                        <el-input placeholder="请输入" v-model="numbsetForm.retain"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="增加量" prop="increase" label-width="120px">
                        <el-input placeholder="请输入" v-model="numbsetForm.increase"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8" v-show='numbsetForm.isMultiple!="1"'>
                      <el-form-item label="序列号" prop="serialnum" label-width="120px">
                        <el-input placeholder="请输入" v-model="numbsetForm.serialnum"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="描述" prop="remarks" label-width="120px">
                        <el-input placeholder="请输入" v-model="numbsetForm.remarks"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-collapse-item>

                <div class="el-collapse-item pt10 pr20 pb20" aria-expanded="true" accordion>
                  <el-tabs v-model="activeName" ref="tabs">
                    <el-tab-pane label="编号的段落设置" name="first">
                      <div class="table-func table-funcb pull-right">
                        <el-button type="success" size="mini" @click="add">
                          <i class="icon-add"></i>
                          <font>新建</font>
                        </el-button>
                      </div>
                      <el-table :data="numbsetForm.numberPrefixList" row-key="ID" border stripe :fit="true" highlight-current-row="highlight-current-row" style="width: 100%;" :default-sort="{prop:'numbsetForm.numberPrefixList', order: 'descending'}">
                        <el-table-column prop="sort" label="排序" width="150px">
                          <template slot-scope="scope">
                            <el-form-item :prop="'numberPrefixList.'+scope.$index + '.sort'" :rules="[{required: true, message: '请输入数字',trigger: 'blur',}
														]">
                              <el-input size="small" v-model="scope.row.sort" placeholder="请输入">
                              </el-input>
                            </el-form-item>
                          </template>
                        </el-table-column>

                        <el-table-column prop="prefix" label="前缀" width="150px">
                          <template slot-scope="scope">
                            <el-form-item :prop="'numberPrefixList.'+scope.$index + '.prefix'">
                              <el-input size="small" v-model="scope.row.prefix" placeholder="请输入">
                              </el-input>
                            </el-form-item>
                          </template>
                        </el-table-column>

                        <el-table-column prop="suffix" label="后缀" width="150px">
                          <template slot-scope="scope">
                            <el-form-item :prop="'numberPrefixList.'+scope.$index + '.suffix'">
                              <el-input size="small" v-model="scope.row.suffix" placeholder="请输入">
                              </el-input>
                            </el-form-item>
                          </template>
                        </el-table-column>

                        <el-table-column prop="category" label="类型" width="300px">
                          <template slot-scope="scope">
                            <el-form-item :prop="'numberPrefixList.'+scope.$index + '.category'" :rules="[{required: true, message: '请输入', trigger: 'blur'}]">
                              <el-select v-model="scope.row.category" placeholder="请选择">
                                <el-option v-for="item in numPrefixTypeoption" :key="item.id" :label="item.name" :value="item.code"></el-option>
                              </el-select>
                            </el-form-item>
                          </template>
                        </el-table-column>
                        <el-table-column prop="value" label="值">
                          <template slot-scope="scope">
                            <el-form-item :prop="'numberPrefixList.'+scope.$index + '.value'">
                              <!-- 当类型是自定义的时候 -->
                              <el-input size="small" v-model="scope.row.value" placeholder="请输入" v-show="scope.row.category=='4'||(scope.row.category=='1'&&numbsetForm.isCustomUse=='1')"></el-input>
                              <!-- 当类型是日期 -->
                              <el-select v-model="scope.row.value" placeholder="请选择" v-show="scope.row.category=='2'">
                                <el-option v-for="item in dateFormatoption" :key="item.id" :label="item.name" :value="item.code"></el-option>
                              </el-select>
                              <!-- 业务字段 -->
                              <el-input v-model="scope.row.value" :disabled="edit" v-show="scope.row.category=='1'&& numbsetForm.isCustomUse!='1'">
                                <el-button slot="append" icon="el-icon-search" @click="getcolumnname(numbsetForm.marky,scope.$index)">
                                </el-button>
                              </el-input>
                            </el-form-item>
                          </template>
                        </el-table-column>

                        <el-table-column fixed="right" label="操作" width="120px">
                          <template slot-scope="scope">
                            <el-button @click.native.prevent="deleteRow(scope.$index,scope.row,'numberPrefixList')" type="text" size="small">
                              <i class="icon-trash red"></i>
                            </el-button>
                          </template>
                        </el-table-column>
                      </el-table>
                    </el-tab-pane>

                  </el-tabs>
                </div>
                <div class="el-collapse-item pt10 pr20 pb20" aria-expanded="true" accordion v-show='numbsetForm.isMultiple=="1"'>
                  <el-tabs v-model="activeName1" ref="tab">
                    <el-tab-pane label="流水号/序号" name="first">
                      <el-table :data="numbsetForm.numberSerialnoList" row-key="ID" border stripe :fit="true" highlight-current-row style="width: 100%;" @cell-click="iconOperation" :default-sort="{prop:'dataInfo.numberSerialnoList', order: 'descending'}">

                        <el-table-column prop="numberPrefix" label="编号前缀">
                          <template slot-scope="scope">
                            <el-form-item :prop="'numberSerialnoList.'+scope.$index + '.numberPrefix'">
                              <span>{{scope.row.numberPrefix}}</span>
                            </el-form-item>
                          </template>
                        </el-table-column>

                        <el-table-column prop="serialnum" label="序号" sortable width="420px">
                          <template slot-scope="scope">
                            <el-form-item :prop="'numberSerialnoList.'+scope.$index + '.serialnum'">
                              <el-input size="small" v-model="scope.row.serialnum" placeholder="请输入"></el-input>
                            </el-form-item>
                          </template>
                        </el-table-column>
                        <el-table-column fixed="right" label="操作" width="120">
                          <template slot-scope="scope">
                            <el-button @click.native.prevent="deleteRow(scope.$index,scope.row,'numberSerialnoList')" type="text" size="small">
                              <i class="icon-trash red"></i>
                            </el-button>
                          </template>
                        </el-table-column>
                      </el-table>
                    </el-tab-pane>
                  </el-tabs>
                </div>
              </el-collapse>
            </div>
          </el-form>
        </div>
            </el-tab-pane>
        </el-tabs>
            
      <!-- 弹出 -->
      <appmask ref="appchild" @appdata='appdata'></appmask>
      <datamask ref="datachild" @appdata='datadata'></datamask>
      <colummask ref="columchild" @columdata='columdata'></colummask>
  </div>
</template>

<script>

import appmask from './applicationmask.vue'//应用管理
import datamask from './datamask.vue'//数据管理
import colummask from './colummask.vue'
export default {
  name: 'masks',
  components: {
    appmask,
    datamask,
    colummask,
  },
  data() {
    return {
      currentDetailTabsModel:"详情",
      drawer:false,
      loading: false,
      options: [{
        value: '1',
        label: '是'
      }, {
        value: '0',
        label: '否'
      }],

      value: '',
      basic_url: Config.dev_url,
      selMenu: [],
      dialogVisible: false, //对话框
      edit: true, //禁填
      activeNames: ['1', '2', '3'], //手风琴数量
      activeName: "first", //tabs
      activeName1: "first",
      show: false,
      isok1: true,
      isok2: false,
      numPrefixTypeoption: [],//类型
      dateFormatoption: [],
      initDateFormatoption: [],
      rules: {
        markx: [{ required: true, message: '必填', }],
        marky: [{ required: true, message: '必填', }],
        retain: [{ required: true, message: '必填', }],
        increase: [{ required: true, message: '必填', }],
        initformat: [{ required: true, message: '必填', }]
        // S_NUM:[
        // 	{ required: true, message: '必填', trigger: 'blur'},
        // 	{ validator: this.Validators.isInteger, trigger: 'blur'}
        // ],

      },
      addtitle: true,
      noedit: false,//可编辑
      views: false,//录入修改人信息
      numbsetForm: {
        isCustomUse: '0',
        isMultiple: '0',
        isInitbydate: '0',
        markx: '',
        marky: '',
        markz: '',
        columnname: '',
        remarks: '',
        initformat: '',
        initnum: '',
        increase: '',
        issplicingdate: '',
        splicingformat: '',
        serialnum: '',
        retain: '',
        createuser: '',
        createuserdesc: '',
        updateuser: '',
        updateuserdesc: '',
        numberPrefixList: [],
      }
    };
  },
  methods: {
    add() {
      var obj = {
        sort: '',
        category: '',
        value: '',
        suffix: '',
        prefix: '',

      };
      this.numbsetForm.numberPrefixList.push(obj);
    },
    iconOperation(row, column, cell, event) {
      if (column.property === "iconOperation") {
        row.isEditing = !row.isEditing;
      }
    },

    //form表单内容清空
    resetNew() {
      this.numbsetForm = {
        isCustomUse: '0',
        isMultiple: '0',
        isInitbydate: '0',
        markx: '',
        marky: '',
        markz: '',
        remarks: '',
        columnname: '',
        initformat: '',
        initnum: '',
        increase: '',
        issplicingdate: '',
        splicingformat: '',
        serialnum: '',
        retain: '',
        createuser: '',
        createuserdesc: '',
        updateuser: '',
        updateuserdesc: '',
        numberPrefixList: [],
      }
    },
    getapp() {
      this.$refs.appchild.visible();
      // this.$refs.appchild.requestData();
    },
    appdata(val) {
      this.numbsetForm.markx = val;
    },
    //表
    getdata() {
      if (this.numbsetForm.markx != '' && this.numbsetForm.markx != undefined && this.numbsetForm.markx != null) {
        this.$refs.datachild.visible(this.numbsetForm.markx);
      } else {
        this.$message({
          message: '请先选择应用',
          type: 'warning'
        });
      }
    },
    datadata(val) {
      this.numbsetForm.marky = val;
    },
    //机构赋值
    deptdata(val) {
      this.numbsetForm.numberPrefixList[this.index].valueDesc = val[1];
      this.numbsetForm.numberPrefixList[this.index].value = val[4];
    },
    getcolumnname(marky, indexs) {
      this.indexs = indexs;
      if (this.numbsetForm.marky != '' && this.numbsetForm.marky != undefined && this.numbsetForm.marky != null) {
        // && !(indexs == '' || indexs == undefined || indexs == null)    不知道这个判断有没有用先放这里了    0与'' 比较是true
        this.$refs.columchild.requestData(marky);
      } else {
        this.$message({
          message: '请先选择表',
          type: 'warning'
        });
      }


    },
    //机构赋值
    columdata(val) {
      if (typeof (this.indexs) == "undefined") {
        this.numbsetForm.columnname = val;
      } else {
        this.numbsetForm.numberPrefixList[this.indexs].value = val;
      }
    },
    addBtn() {
      this.numbsetForm = {
        isCustomUse: '0',
        isMultiple: '0',
        isInitbydate: '0',
        markx: '',
        marky: '',
        markz: '',
        remarks: '',
        columnname: '',
        initformat: '',
        initnum: '',
        increase: '',
        issplicingdate: '',
        splicingformat: '',
        serialnum: '',
        retain: '',
        createuser: '',
        createuserdesc: '',
        updateuser: '',
        updateuserdesc: '',
        numberPrefixList: [],
      };
      this.currentDetailTabsModel = "详情"
      this.addtitle = true;
      this.isok2 = false;
      this.isok1 = true;
    },
    data(id) {
      var url = Config.dev_url + '/api-apps/number/' + id;
      this.$axios.get(url, {}).then((res) => {
        console.log(res)
        this.numbsetForm = res.data;
      }).catch((err) => {
      })
    },
    //这是查看
    view(item) {
      this.currentDetailTabsModel = "详情"
      this.data(item.id);
      this.getupdateuserdesc()
      this.getcreateuserdesc()
      this.addtitle = false;
      
      this.isok2 = false;
      this.isok1 = true;
    },
    //刪除新建行
    deleteRow(index, row, listName) {
      var TableName = '';
      if (listName == 'numberPrefixList') {
        TableName = 'numberPrefixList';
      } else {
        TableName = 'numberSerialnoList';
      }
      if (row.id) {
        var url = Config.dev_url + '/api-user/number/' + TableName + '/' + row.id;
        this.$confirm('确定删除此数据吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({
          value
        }) => {
          this.$axios.delete(url, {}).then((res) => {
            if (res.data.resp_code == 0) {
              this.numbsetForm[TableName].splice(index, 1);
              this.$message({
                message: '删除成功',
                type: 'success'
              });
            } else {
              this.$message({
                message: res.data.resp_msg,
                type: 'error'
              });
            }
          }).catch((err) => {
          });
        }).catch(() => {

        });
      } else {
        this.numbsetForm[TableName].splice(index, 1);
      }
    },
    //点击关闭按钮
    close() {
      this.show = false;
    },
    cancelForm() {
      this.show = false;
      this.resetNew();
    },
    toggle(e) {
      if (this.isok1 == true) {
        this.maxDialog();
      } else {
        this.rebackDialog();
      }
    },
    maxDialog(e) { //定义大弹出框一个默认大小
      this.isok1 = false;
      this.isok2 = true;
      $(".mask_div").css("width", "100%");
      $(".mask_div").height(document.body.clientHeight - 60);
      $(".mask_div").css("top", "60px");
      $(".mask_divbg").css("top", "0px");
    },
    //还原按钮
    rebackDialog() { //大弹出框还原成默认大小
      this.isok1 = true;
      this.isok2 = false;
      $(".mask_div").css("width", "85%");
      $(".mask_div").css("height", "90%");
      $(".mask_div").css("top", "0px");
      $(".mask_divbg").css("top", "100px");
    },
    //保存
    saveBtn() {
      this.loading = true;
      this.$refs.numbsetForm.validate((valid) => {
        if (valid) {
          var url = Config.dev_url + '/api-apps/number/saveOrUpdate';
          this.$axios.post(url, this.numbsetForm).then((res) => {
            this.loading = false;
            //resp_code == 0是后台返回的请求成功的信息
            if (res.data.code == 0) {
              this.$message({
                message: '保存成功',
                type: 'success'
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error'
              });
            }
          }).catch((err) => {
          });
        } else {
          this.loading = false;
          this.$message({
            message: '未填写完整，请填写',
            type: 'warning'
          });
        }
      });

    },
    handleClose(done) {//大弹出框确定关闭按钮
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => {
          console.log('取消关闭');
          $('.v-modal').hide();
        });
    },
    //编号的段落设置类型
    numPrefixType() {
      var url = Config.dev_url + '/api-user/dicts/findChildsByCode?code=numPrefixType';
      this.$axios.get(url, {}).then((res) => {
        this.numPrefixTypeoption = res.data;
      }).catch((wrong) => {
      })
    },
    //编号的段落设置类型中的日期
    dateFormat() {
      var url = Config.dev_url + '/api-user/dicts/findChildsByCode?code=dateFormat';
      this.$axios.get(url, {}).then((res) => {
        this.dateFormatoption = res.data;
      }).catch((wrong) => {
      })
    },
    //初始化日期格式
    initDateFormat() {
      var url = Config.dev_url + '/api-user/dicts/findChildsByCode?code=initDateFormat';
      this.$axios.get(url, {}).then((res) => {
        this.initDateFormatoption = res.data;
      }).catch((wrong) => {
      })
    },
    //关闭抽屉按钮点击
        closeBtn(){
            this.drawer = false
            this.$emit("requestData")
        },
        //获取创建人描述
        getcreateuserdesc() {
            if (!!this.numbsetForm.createuser) {
                var url = Config.dev_url + '/api-user/users/' + this.numbsetForm.createuser
                this.$axios.get(url).then((res) => {
                    this.$set(this.numbsetForm, 'createuserdesc', res.data.nickname)
                }).catch((err) => {
                });
            }
        },
        //获取修改人描述
        getupdateuserdesc() {
            if (!!this.numbsetForm.updateuser) {
                var url = Config.dev_url + '/api-user/users/' + this.numbsetForm.updateuser
                this.$axios.get(url).then((res) => {
                    this.$set(this.numbsetForm, 'updateuserdesc', res.data.nickname)
                }).catch((err) => {
                });
            }
        },
        //tab选项卡点击
    tabClick(tab){
        if(tab.label == "列表"){
            this.$store.commit('setcurrentShowPage',1)
            this.$emit("requestData")
        }else{
            this.$store.commit('setcurrentShowPage',2)
        }
    },
  },
  mounted() {
    this.numPrefixType();
    this.dateFormat();
    this.initDateFormat();
  },
  computed:{
        //当前左侧菜单选中的信息
        currentSelectMenuData(){
            return this.$store.state.currentSelectMenuData
        },
        //当前登录人信息
        currentuser() {
            return this.$store.state.currentuser
        },
    }
}
</script>

<style scoped>
</style>